const UploadIcon = () => {
  return (
    <svg viewBox="0 0 18 18">
      <path
        d="M56.367,47.367a9,9,0,1,0,9,9A9,9,0,0,0,56.367,47.367ZM59.9,55.4a.75.75,0,0,1-1.061,0l-1.72-1.72v7.189a.75.75,0,0,1-1.5,0V53.678L53.9,55.4a.75.75,0,0,1-1.061-1.061l3-3a.75.75,0,0,1,1.06,0l3,3A.75.75,0,0,1,59.9,55.4Z"
        transform="translate(-47.367 -47.367)"
      />
    </svg>
  );
};

export default UploadIcon;
